var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDotSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    style: {
      width: "2em",
      height: "2em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M593.180416 494.907717c0 28.253484-22.89443 51.16531-51.158147 51.16531-28.260647 0-51.172473-22.911826-51.172473-51.16531 0-28.269857 22.911826-51.16531 51.172473-51.16531C570.285986 443.742407 593.180416 466.63786 593.180416 494.907717z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotSvgrepoCom);
export default __webpack_public_path__ + "static/media/dot-svgrepo-com.48a94de99c5d9e07a9b431fc002e952d.svg";
export { ForwardRef as ReactComponent };